export default __webpack_public_path__ + "./assets/Mika__442445dc3b96a7ea808f5edbbb105819.png";